import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideLoadingBarInterceptor } from '@ngx-loading-bar/http-client';

import { HttpAuthInterceptor } from '@app/core/interceptors/http-auth-interceptor';
import { NgbDateCustomParserFormatter } from '@app/core/vendors/parser/ngb-date-formatter';
import { CoreModule } from '@core/core.module';
import {
  NgbDateAdapter,
  NgbDateNativeAdapter,
  NgbDateParserFormatter
} from '@ng-bootstrap/ng-bootstrap';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import packageJson from '../../package.json';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FullscreenLoaderComponent } from './core/components/fullscreen-loader/fullscreen-loader.component';
import { PayloadEncryptionInterceptor } from './core/interceptors/payload-encryption.interceptor';
import { reducers } from './core/store/reducers';

export const APP_VERSION = new InjectionToken<string>('appVersion');

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    BrowserAnimationsModule,
    LoadingBarModule,
    StoreModule.forRoot(reducers),
    StoreDevtoolsModule.instrument({
      maxAge: 10,
      connectInZone: true
    }),
    FullscreenLoaderComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PayloadEncryptionInterceptor, multi: true },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: APP_VERSION, useValue: packageJson.version },
    provideHttpClient(withInterceptorsFromDi()),
    provideLoadingBarInterceptor()
  ]
})
export class AppModule {}
